class ProductCarousel extends HTMLElement {
  constructor() {
    super();
    this.carousel = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.carousel = new Splide(this.querySelector('.splide'),
      {
        arrows: false,
        perPage: 4,
        gap: 'var(--spacing-sm)',
        drag: 'free',
        breakpoints: {
          768: {
            perPage: 1.5,
            gap: 'var(--spacing-xs)',
            focus: 0,
          }
        },
      },
    );

    this.carousel.mount();
  }
}

customElements.define('product-carousel', ProductCarousel);
